document.addEventListener('DOMContentLoaded', function () {
  // Initialize first tab on load
  function initializeFirstTab() {
    const firstTab = document.querySelector('.faq-tab');
    const firstContent = document.querySelector(
      `.faq-content[data-tab-content="${firstTab?.dataset.tab}"]`,
    );

    if (firstTab && firstContent) {
      // Remove active classes from all
      document
        .querySelectorAll('.faq-tab.active, .faq-content.active')
        .forEach((el) => {
          el.classList.remove('active');
        });

      // Activate first tab
      firstTab.classList.add('active');
      firstContent.classList.add('active');

      // Set mobile dropdown to show first option by default
      const dropdownText = document.querySelector('.faq-dropdown-text');
      const firstOption = document.querySelector('.faq-dropdown-option');
      if (dropdownText && firstOption) {
        dropdownText.textContent = firstOption.dataset.text;
        firstOption.classList.add('selected');
      }
    }
  }

  // Call initialization
  initializeFirstTab();

  // Function to update dropdown options visibility
  function updateDropdownVisibility() {
    const selectedOption = document.querySelector(
      '.faq-dropdown-option.selected',
    );
    const allOptions = document.querySelectorAll('.faq-dropdown-option');

    allOptions.forEach((option) => {
      if (option === selectedOption) {
        option.style.display = 'none';
      } else {
        option.style.display = 'block';
      }
    });
  }

  // Function to initialize first question for a specific tab
  function initializeFirstQuestionForTab(tabValue) {
    const tabContent = document.querySelector(
      `.faq-content[data-tab-content="${tabValue}"]`,
    );
    if (tabContent) {
      const firstQuestion = tabContent.querySelector('.faq-question');
      const firstAnswer = tabContent.querySelector('.faq-answer');

      // Reset all questions in this tab first
      tabContent
        .querySelectorAll('.faq-question')
        .forEach((q) => q.classList.remove('active'));
      tabContent.querySelectorAll('.faq-answer').forEach((a) => {
        a.classList.remove('active');
        a.style.maxHeight = '0';
      });

      // Open first question if it exists
      if (firstQuestion && firstAnswer) {
        firstQuestion.classList.add('active');
        firstAnswer.classList.add('active');

        // Calculate height for smooth animation
        const height = firstAnswer.scrollHeight + 'px';
        firstAnswer.style.setProperty('--calculated-height', height);
        firstAnswer.style.maxHeight = height;
      }
    }
  }

  // Initialize first question for the initially active tab
  const initialActiveTab = document.querySelector('.faq-tab.active');
  if (initialActiveTab) {
    initializeFirstQuestionForTab(initialActiveTab.dataset.tab);
  }

  // Custom Mobile Dropdown Logic
  const dropdownTrigger = document.getElementById('faq-dropdown-trigger');
  const dropdownMenu = document.getElementById('faq-dropdown-menu');
  const dropdownText = document.querySelector('.faq-dropdown-text');
  const dropdownOptions = document.querySelectorAll('.faq-dropdown-option');

  if (dropdownTrigger && dropdownMenu) {
    // Initialize dropdown visibility on load
    setTimeout(() => {
      updateDropdownVisibility();
    }, 100);

    // Toggle dropdown
    dropdownTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdownTrigger.classList.toggle('active');
      dropdownMenu.classList.toggle('active');

      // Update visibility when opening dropdown
      if (dropdownMenu.classList.contains('active')) {
        updateDropdownVisibility();
      }
    });

    // Handle option selection
    dropdownOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const selectedValue = this.dataset.value;
        const selectedText = this.dataset.text;

        // Remove selected class from all options
        dropdownOptions.forEach((opt) => opt.classList.remove('selected'));

        // Add selected class to clicked option
        this.classList.add('selected');

        // Update trigger text
        dropdownText.textContent = selectedText;

        // Update dropdown visibility
        updateDropdownVisibility();

        // Close dropdown
        dropdownTrigger.classList.remove('active');
        dropdownMenu.classList.remove('active');

        // Update FAQ content
        document
          .querySelector('.faq-content.active')
          ?.classList.remove('active');
        document.querySelector('.faq-tab.active')?.classList.remove('active');

        document
          .querySelector(`.faq-content[data-tab-content="${selectedValue}"]`)
          ?.classList.add('active');
        document
          .querySelector(`.faq-tab[data-tab="${selectedValue}"]`)
          ?.classList.add('active');

        // Initialize first question for the selected tab
        initializeFirstQuestionForTab(selectedValue);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function () {
      dropdownTrigger.classList.remove('active');
      dropdownMenu.classList.remove('active');
    });

    // Prevent closing when clicking inside dropdown
    dropdownMenu.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  // Desktop tab switching
  const tabs = document.querySelectorAll('.faq-tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      document.querySelector('.faq-tab.active')?.classList.remove('active');
      document.querySelector('.faq-content.active')?.classList.remove('active');

      tab.classList.add('active');
      const tabName = tab.dataset.tab;
      document
        .querySelector(`.faq-content[data-tab-content="${tabName}"]`)
        ?.classList.add('active');

      // Initialize first question for the selected tab
      initializeFirstQuestionForTab(tabName);

      // Sync mobile dropdown
      if (dropdownText) {
        const matchingOption = document.querySelector(
          `.faq-dropdown-option[data-value="${tabName}"]`,
        );
        if (matchingOption) {
          dropdownOptions.forEach((opt) => opt.classList.remove('selected'));
          matchingOption.classList.add('selected');
          dropdownText.textContent = matchingOption.dataset.text;
          updateDropdownVisibility();
        }
      }
    });
  });

  // Enhanced smooth question expanding
  const questions = document.querySelectorAll('.faq-question');
  questions.forEach((question) => {
    question.addEventListener('click', () => {
      let noTabs = question.classList.contains('faq-simple-question');

      const answer = question.nextElementSibling;
      const isOpening = !answer.classList.contains('active');

      // Calculate actual height for smooth animation
      if (isOpening) {
        answer.style.maxHeight = '0';
        answer.classList.add('active');
        const height = answer.scrollHeight + 'px';
        answer.style.setProperty('--calculated-height', height);
        answer.style.maxHeight = height;
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        // Trigger reflow
        void answer.offsetHeight;
        answer.style.maxHeight = '0';
      }

      // Toggle active class after setting heights
      setTimeout(() => {
        question.classList.toggle('active');
        if (!isOpening) {
          answer.classList.remove('active');
        }
        if (noTabs) {
          question.closest('.faq-item').classList.toggle('active');
          if (!isOpening) {
            question.closest('.faq-item').classList.remove('active');
          }
        }
      }, 10);
    });
  });
});
